import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from 'react';

interface UseUserPaidCardProps {
  competitionId?: string;
  isPaidApplication: boolean | null | undefined;
}

interface UseUserPaidCardResult {
  userPaidCard: boolean;
  isLoading: boolean;
}

export const useUserPaidCard = ({ competitionId, isPaidApplication }: UseUserPaidCardProps): UseUserPaidCardResult => {
  const [userPaidCard, setUserPaidCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isPaidApplication || !competitionId) {
      setUserPaidCard(false);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    API.request()
      .endpoint(Endpoints.competitions)
      .url('/api/Competition/GetUserCompetitionCards')
      .addQuery('competitionId', competitionId)
      .get()
      .send()
      .then(response => response.json())
      .then(competitionCard => {
        setUserPaidCard(!!competitionCard?.length);
      })
      .catch(() => {
        setUserPaidCard(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [competitionId, isPaidApplication]);

  return { userPaidCard, isLoading };
};
import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from 'react';

interface UseUserPaidCardProps {
  competitionId?: string;
  isPaidApplication: boolean | null | undefined;
}

interface UseUserPaidCardResult {
  userPaidCard: boolean;
  isLoading: boolean;
}

export const useUserPaidCard = ({ competitionId, isPaidApplication }: UseUserPaidCardProps): UseUserPaidCardResult => {
  const [userPaidCard, setUserPaidCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isPaidApplication || !competitionId) {
      setUserPaidCard(false);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    API.request()
      .endpoint(Endpoints.competitions)
      .url('/api/Competition/GetUserCompetitionCards')
      .addQuery('competitionId', competitionId)
      .get()
      .send()
      .then(response => response.json())
      .then(competitionCard => {
        setUserPaidCard(!!competitionCard?.length);
      })
      .catch(() => {
        setUserPaidCard(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [competitionId, isPaidApplication]);

  return { userPaidCard, isLoading };
};
